
import Button from '../../../components/base/Button';

export default function ContactFormSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Entre em Contato
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Estamos prontos para transformar suas ideias em realidade. Entre em contato conosco e solicite seu orçamento personalizado.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#5C1A24] rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Telefone</h3>
                  <p className="text-gray-600">(11) 98034-1891</p>
                </div>
              </div>
              
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#5C1A24] rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">E-mail</h3>
                  <p className="text-gray-600">pep.enarq@hotmail.com</p>
                </div>
              </div>
              
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#5C1A24] rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Endereço</h3>
                  <p className="text-gray-600">São Paulo, SP</p>
                </div>
              </div>
            </div>
          </div>

          {/* WhatsApp Contact Section */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Solicite seu Orçamento
            </h3>
            
            <div className="bg-gray-50 rounded-lg p-8 text-center">
              <div className="w-16 h-16 bg-[#5C1A24] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
              
              <h4 className="text-xl font-semibold text-gray-900 mb-4">
                Fale conosco pelo WhatsApp
              </h4>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Entre em contato diretamente pelo WhatsApp para solicitar seu orçamento personalizado. Nossa equipe está pronta para atender você e esclarecer todas as suas dúvidas sobre seu projeto.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center justify-center text-sm text-gray-600">
                  <i className="ri-time-line mr-2 text-[#5C1A24]"></i>
                  <span>Resposta rápida e personalizada</span>
                </div>
                <div className="flex items-center justify-center text-sm text-gray-600">
                  <i className="ri-shield-check-line mr-2 text-[#5C1A24]"></i>
                  <span>Consultoria gratuita</span>
                </div>
                <div className="flex items-center justify-center text-sm text-gray-600">
                  <i className="ri-award-line mr-2 text-[#5C1A24]"></i>
                  <span>6+ anos de experiência</span>
                </div>
              </div>
              
              <a
                href="https://api.whatsapp.com/send/?phone=5511980341891&text=Ol%C3%A1%21+Gostaria+de+saber+mais+sobre+os+servi%C3%A7os+da+P&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-[#5C1A24] text-white py-4 px-6 rounded-lg font-semibold hover:bg-[#4A1520] transition-colors flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Solicite seu Orçamento pelo WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
